import { render, staticRenderFns } from "./LayawayPayments.vue?vue&type=template&id=04ea5a6a&scoped=true"
import script from "./LayawayPayments.vue?vue&type=script&lang=js"
export * from "./LayawayPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea5a6a",
  null
  
)

export default component.exports